<mat-toolbar class="app-header">  
    <div class="app-header flex-row-container">
      <mat-icon class="pointer app-header__menu app-header__appName m-t4" [routerLink]="['../home']">home</mat-icon> 
      <span class="app-header__appName pointer m-l5" [routerLink]="['../home']">{{appName | uppercase}}</span>
      <span (click)="openModelDialog('DEBUG')" class="m-l10 DEBUG">...</span>
    </div>
    <div class="flex-row-container">        
      <div class="m-r10 flex-col-end">
        <div class="app-header__username">
            {{userName}}          
        </div>
        <span class="app-header__companyname">ROCKEFELLER CAPITAL MANAGEMENT</span>      
      </div>
      <mat-icon *ngIf="isSuperUser" [matMenuTriggerFor]="repMenu" style="font-size: 30px !important;" class="pointer"  inline=true>more_vert</mat-icon>      
      <mat-menu #repMenu="matMenu" class="md-lg-font m-lr30 p20" >
        <div  class="m-tb10" (click)="$event.stopPropagation();">
          <mat-form-field class="m-l30" style="width: 100px;">
            <input type="text" matInput placeholder="Rep Id" maxlength="30" [formControl]="txtRepId"  
            (keyup.enter)="setRepId(); trigger.closeMenu();" autofocus>
            <mat-error *ngIf="txtRepId.invalid">
              Invalid
            </mat-error>
          </mat-form-field>
        </div>
        <div class="m-r10 m-t10 p-t10 border-t-gray" >
          <button mat-raised-button color="basic" class="m-lr10">Cancel</button>
          <button mat-raised-button color="primary" [disabled]="(isSuperUser && !txtRepId.value)" (click)="setRepId();" class="saveButton m-l10">Apply</button>
        </div>
      </mat-menu>
      <mat-icon class="pointer app-menu m-t3" style="color: var(--black);" (click)="onToggleTheme()">format_color_fill</mat-icon> 
    </div>
</mat-toolbar>
<div #trigger=matMenuTrigger [matMenuTriggerFor]="repMenu"></div>
<router-outlet></router-outlet>